import {HttpClient, HttpParams} from '@angular/common/http';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {Injectable} from "@angular/core";
import {tap} from "rxjs/operators";
import {DefaultService} from "../../shared/_services/abstract/default.service";

@Injectable()
export class PaymentsService extends DefaultService {

    link: any;
    filters: any = {};
    onItemUpdate: BehaviorSubject<any>;
    onSearchTextChanged: Subject<any>;
    constructor(public override http: HttpClient) {
        super(http);
        this.setResourceLink('secured/userPayments');
        this.onItemUpdate = new BehaviorSubject([]);
        this.onSearchTextChanged = new Subject();
    }

}
